import $http from "../../axios";
import { Notification } from "element-ui";
import { defaultType } from "./state";
import { v4 as uuidv4 } from "uuid";

const getJsonByKey = (state, key) => {
    return state.configData[key] || null;
};

export async function getRowData({ commit, state }, key = defaultType) {
    try {
        const lastKey = state.lastKey;
        commit("setCurrentRowData", { key: lastKey, data: state.rowData });

        const currentData = state.currentRowData[key];
        const jsonData = getJsonByKey(state, key);

        const skipIndexes =
            state.indexesToSkip && state.indexesToSkip[key]
                ? state.indexesToSkip[key]
                : [];

        // Si ya existe data en el estado, filtramos los índices a ignorar
        if (currentData && currentData.length > 0) {
            const filteredData = currentData.filter(
                (row, idx) =>
                    !skipIndexes.includes(
                        row.index !== undefined ? row.index : idx
                    )
            );

            commit("setLastKey", key);
            commit("setRowData", filteredData);
            commit("setCurrentRowData", { key, data: currentData });
            return;
        }

        // Si trae data desde JSON, filtramos también
        if (jsonData && jsonData.length > 0) {
            const rowsWithUid = jsonData
                .filter(row => !skipIndexes.includes(row.index))
                .map(row => ({
                    ...row,
                    _uid: uuidv4()
                }));

            commit("setLastKey", key);
            commit("setRowData", rowsWithUid);
            commit("setCurrentRowData", { key, data: rowsWithUid });
            return;
        }

        throw new Error("No se encontró información.");
    } catch (error) {
        console.error(error);
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    }
}

export async function getItemRowData({ commit, state }, params) {
    return new Promise((resolve, reject) => {
        try {
            const { key = defaultType, index } = params || {};
            const data = getJsonByKey(state, key);

            if (!data || data.length === 0) {
                throw new Error("No se encontró información.");
            }

            const row = data.find(r => String(r.index) === String(index));

            if (!row) {
                throw new Error(
                    `No se encontró un registro con index = ${index}`
                );
            }

            resolve(row);
        } catch (error) {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
            reject(error);
        }
    });
}

export async function getColumnDefs({ commit, state }, key = defaultType) {
    return await new Promise(async (resolve, reject) => {
        try {
            if (state.columnDefs && state.columnDefs.length > 0) {
                resolve(state.columnDefs);
            } else {
                throw new Error("No se encontro informacion.");
            }
        } catch (error) {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
            reject(error);
        }
    });
}

export async function deleteRowById({ commit, state }, uid) {
    try {
        const updatedRows = state.rowData.filter(row => row._uid !== uid);

        commit("setRowData", updatedRows);
    } catch (error) {
        Notification.error({
            title: "Error al eliminar",
            message: error.message || "No se pudo eliminar la fila.",
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    }
}

export async function addEmptyRow({ commit, state }) {
    try {
        const newRow = {
            index: null,
            description: null,
            cta_from: [],
            cta_to: [],
            type: null,
            id: null,
            _uid: uuidv4()
        };

        const updatedRows = [newRow, ...state.rowData];

        commit("setRowData", updatedRows);
    } catch (error) {
        Notification.error({
            title: "Error al agregar fila",
            message: error.message || "No se pudo agregar una nueva fila.",
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    }
}

export function generatePdfTaxLiquidator({ state }) {
    return new Promise(async (resolve, reject) => {
        const payload = {
            ...state.paramsReport,
            dateStart:
                state.paramsReport.date && state.paramsReport.date.length > 0
                    ? state.paramsReport.date[0]
                    : "",
            dateEnd:
                state.paramsReport.date && state.paramsReport.date.length > 0
                    ? state.paramsReport.date[1]
                    : "",
            date: undefined,
            data: state.rowData
        };

        try {
            const response = await $http.post(
                `/api/generate-pdf-tax-liquidator`,
                payload
            );

            resolve(response.data);
        } catch (error) {
            reject(error);
        }
    });
}

export async function fetchTaxLiquidatorConfig({ commit }) {
    try {
        const response = await $http.get(`/api/tax-liquidator-config`);
        const configs = response.data;

        // Estructura inicial
        const formattedData = {
            "1_iva_form_300": [],
            "2_ret_fuente_form_350": [],
            "3_renta_form_110": [],
            "4_ica_declaration": []
        };

        // Agrupar por "form"
        configs.forEach(item => {
            if (formattedData[item.form]) {
                formattedData[item.form].push(item);
            }
        });

        // Guardar en el store
        commit("setConfigData", formattedData);

        return formattedData;
    } catch (error) {
        console.error("Error fetching tax liquidator config:", error.message);
        throw error;
    }
}

export async function updateTaxLiquidatorConfig({ commit }, data) {
    try {
        const response = await $http.put(
            `/api/tax-liquidator-config/${data.id}`,
            data
        );

        Notification.success({
            title: "Aviso",
            message: "Actualizado con exito",
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching tax liquidator config:", error.message);
        throw error;
    }
}



// WEBPACK FOOTER //
// ./src/modules/tax-liquidator/actions.js